import { googleFetch } from '../client';

export type GoogleDriveDrivesCreateRequest = {
  name: string;
};

export type GoogleDriveDrivesCreateResponse = {
  id: string;
  name: string;
};

export async function googleDriveDrivesCreate(
  params: GoogleDriveDrivesCreateRequest
): Promise<GoogleDriveDrivesCreateResponse> {
  return googleFetch<GoogleDriveDrivesCreateResponse>(
    '/rpc/google_drive_drives_create',
    {
      body: params,
    }
  );
}
